<template>
  <div>
    <b-row class="mb-4">
      <b-col>
        <fcc-select v-model="fase" :options="listaFases" :clearable="false"> Fase </fcc-select>
      </b-col>

      <b-col>
        <fcc-select
          v-model="lista"
          :options="listas"
          label-field="lista"
          value-field="idlista"
          :clearable="false"
          >Lista</fcc-select
        >
      </b-col>

      <b-col>
        <fcc-select
          v-model="situacao"
          :options="situacoes"
          :disabled="!lista"
          label-field="situacao"
          value-field="idoutrafaseprocessamentosituacao"
          :clearable="false"
          >Situacao</fcc-select
        >
      </b-col>
    </b-row>

    <b-row align-h="end">
      <b-col class="mb-3 text-right">
        <fcc-button
          :disabled="!fase || !lista || !situacao"
          @click="obterListaImportacoesPorProcessamento"
          >Buscar</fcc-button
        >
      </b-col>
    </b-row>

    <div class="card p-3 mb-3" v-if="items.length > 0">
      <b-row>
        <b-col>
          <fcc-table
            striped
            hover
            pdf
            xls
            csv
            responsive
            search
            pagination
            field-visibility
            :titlePage="titlePage"
            :titlePDF="titlePage"
            :fields="fields"
            :items="items"
            :porPage="itemPorPage"
            :key="keyTable"
            @row-selected="selecionaItems"
          />
        </b-col>
      </b-row>

      <b-row align-h="end">
        <b-col class="mb-3 text-right">
          <fcc-button :disabled="dadosSelecionados.length <= 0" @click="importar"
            >Importar</fcc-button
          >
        </b-col>
      </b-row>
    </div>

    <fcc-logs-importacao
      :base-url-publicacao="baseUrlPublicacao"
      :idoutfase="idoutfase"
      :controle-page="controlePage"
      :tp-importacao="tpImportacao"
      :logs="logs"
      @excluir="excluirImportacoesProcessamento"
    />
  </div>
</template>
<script>
import axios from 'axios'
import FccLogsImportacao from './fccLogsImportacao.vue'
import fccGravarLog from './fccGravarLog.vue'

export default {
  mixins: [fccGravarLog],
  props: {
    baseUrlPublicacao: String,
    idoutfase: Number,
    controlePage: Object,
    tpImportacao: Number,
    listaFases: Array
  },
  data() {
    return {
      titlePage: 'Importação de Candidatos - Processamento',
      fase: '',
      lista: '',
      situacao: '',
      listas: [],
      situacoes: [],
      itemPorPage: '10',
      dadosSelecionados: [],
      items: [],
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'idpublicacao', label: 'Publicação', sortable: true },
        { key: 'idoutfase', label: 'Outras Fases', sortable: true },
        { key: 'idfase', label: 'Fase', sortable: true },
        { key: 'lista', label: 'Lista', sortable: true },
        { key: 'situacao', label: 'Situação', sortable: true },
        { key: 'codcargo', label: 'Código do Cargo', sortable: true },
        { key: 'cargo', label: 'Cargo', sortable: true },
        { key: 'ninscricoes', label: 'N° Inscrições', sortable: true, totalizar: true },
        { key: 'importados', label: 'N° Importados', sortable: true, totalizar: true }
      ],
      logs: [],
      keyTable: 0
    }
  },
  components: {
    FccLogsImportacao
  },
  created() {
    this.obterOpcoesLista()
    this.listarLogs()
  },
  watch: {
    fase() {
      this.items = []
    },
    lista(value) {
      if (value) {
        this.situacao = ''
        this.obterSituacoesPorIdLista()
      }
    }
  },
  methods: {
    obterOpcoesLista() {
      axios
        .get(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterOpcoesLista',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.listas = data
        })
        .catch(this.setErrorSystem)
    },
    obterSituacoesPorIdLista() {
      const body = {
        idLista: this.lista
      }

      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterSituacoesPorIdLista',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.situacoes = data
        })
        .catch(this.setErrorSystem)
    },
    obterListaImportacoesPorProcessamento() {
      const body = {
        idPublicacao: this.controlePage.idpublicacao,
        idOutraFase: this.idoutfase,
        idFase: this.fase,
        idLista: this.lista,
        idOutraFaseProcessamentoSituacao: this.situacao
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterListaImportacoesPorProcessamento',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          if (data.length === 0) {
            this.callAlert('A busca não retornou resultados.', '', 'error', 'error')
          }

          this.items = data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listarLogs() {
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterLogsImportacaoPorProcessamento',
          {
            id_Publicacao: this.controlePage.idpublicacao,
            id_Outrafase: this.idoutfase
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.logs = data
        })
        .catch(this.setErrorSystem)
    },
    importar() {
      const body = this.dadosSelecionados.map((item) => ({
        idPublicacao: this.controlePage.idpublicacao,
        idOutraFase: this.idoutfase,
        idFase: this.fase,
        idLista: this.lista,
        idOutraFaseProcessamentoSituacao: this.situacao,
        tpImportacaoOutrasFases: this.tpImportacao,
        codCargo: item.codcargo,
        cd_Funcionario: this.dadosUserSession.usuCdFuncionario
      }))

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ImportarCandidatosPorProcessamento',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast('Importado com sucesso.', 'success')
          this.keyTable = this.keyTable + 1
          this.gravarLogImportacaoCandidatosOutrasFases()
          this.obterListaImportacoesPorProcessamento()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    excluirImportacoesProcessamento() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ExcluirImportacoesProcessamento',
          {
            id_Publicacao: this.controlePage.idpublicacao,
            id_OutraFase: this.idoutfase,
            cd_Funcionario: this.dadosUserSession.usuCdFuncionario
          },
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.excluido, 'success')
          this.listarLogs()
          if (this.fase && this.lista && this.situacao) this.obterListaImportacoesPorProcessamento()
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    selecionaItems(value) {
      this.dadosSelecionados = value
    }
  }
}
</script>